import { defineMessages } from 'react-intl-next';

export default defineMessages({
    headerTextHelpCenter: {
        defaultMessage: 'Help centers',
        description: 'Help centers management screen header text',
        id: 'help.center.management.page.header.text',
    },
    headerTextHelpHub: {
        defaultMessage: 'Help hubs',
        description: 'Help centers management screen header text hubs',
        id: 'help.center.management.page.header.text.hubs.non-final',
    },
    headerDescriptionHelpCenter: {
        defaultMessage: 'Set up and manage your help centers here.',
        description: 'Help centers management screen header description',
        id: 'help.center.management.page.header.description',
    },
    headerDescriptionReadMoreLinkHelpCenter: {
        defaultMessage: 'Read more about help centers',
        description: 'Help centers management screen header description read more link',
        id: 'help.center.management.page.header.description.read.more.link',
    },
    headerDescriptionHelpHub: {
        defaultMessage: 'Set up and manage your help hubs here.',
        description: 'Help centers management screen header description',
        id: 'help.center.management.page.header.description.hubs',
    },
    addButtonTextHelpCenter: {
        defaultMessage: 'Create help center',
        description: 'Help centers management screen add help center button text',
        id: 'help.center.management.add.help.center.button.text',
    },
    addButtonTextHelpHub: {
        defaultMessage: 'Create help hub',
        description: 'Help centers management screen create button text',
        id: 'help.center.management.create.button.text.hubs.non-final',
    },
    createOptionHelpCenterTitle: {
        defaultMessage: 'Help center',
        description: 'Help centers management screen create option help center title',
        id: 'help.center.management.create.option.help.center.title',
    },
    createOptionHelpCenterDescription: {
        defaultMessage: 'The default help experience with portals, topics, and more',
        description: 'Help centers management screen create option help center description',
        id: 'help.center.management.create.option.help.center.description',
    },
    createOptionHubTitle: {
        defaultMessage: 'Help hub',
        description: 'Help centers management screen create option hub title',
        id: 'help.center.management.create.option.hub.title.non-final',
    },
    createOptionHubDescription: {
        defaultMessage: 'Create a modern help experience with components and customisation',
        description: 'Help centers management screen create option hub description',
        id: 'help.center.management.create.option.hub.description.non-final',
    },
    genericErrorHeading: {
        defaultMessage: 'Something bad happened',
        description: 'Generic error when something could not be loaded',
        id: 'help.center.management.page.generic.error.heading',
    },
    genericErrorMessage: {
        defaultMessage: 'Looks like we’re having trouble retrieving some information, please refresh the page.',
        description: 'Generic error when something could not be loaded',
        id: 'help.center.management.page.generic.error.message',
    },
    authPageMessage: {
        defaultMessage: `You don't have permission to view this page.`,
        description: 'Message text for unauthorized page of portal reordering',
        id: 'help.center.management.page.un.auth.action.message',
    },
    callToActionUrlText: {
        defaultMessage: 'Go to help center',
        description: 'Call to action text for unauthorized page of portal reordering',
        id: 'help.center.management.page.un.auth.action.text',
    },
    upgradeTitleCreateClick: {
        defaultMessage: 'Upgrade to create new help centers',
        description: 'Popup title to upgrade to create help center',
        id: 'help.center.management.upgrade.title.create.click',
    },
    upgradeDescriptionCreateClick: {
        defaultMessage: 'You need to be on a Premium or Enterprise plan to create multiple help centers on your site.',
        description: 'Popup description to upgrade to create help center',
        id: 'help.center.management.upgrade.description.create.click',
    },
    helpHubEmptyStateHeader: {
        defaultMessage: 'Create modern help hubs to serve your customers',
        description: 'Help hub empty state header',
        id: 'help.center.management.page.help.hub.empty.state.header',
    },
    helpHubEmptyStateDescription: {
        defaultMessage:
            'Empower customers to find answers with knowledge base articles or get support by raising requests in Jira Service Management.',
        description: 'Help hub empty state description',
        id: 'help.center.management.page.help.hub.empty.state.description',
    },
});
